import Vue from '@triotech/vue-core/src/vendor/vue';
import Router from '@triotech/vue-core/src/plugins/router';

const AutoDisconnect = new Vue({
  router: Router,
  computed: {
    navigationType: () => window.performance && window.performance.navigation.type,
    navigationTypes: () => ({ empty: 0, refresh: 1, back: 2 }),
    isEmptyNavigation() {
      return this.navigationType === this.navigationTypes.empty;
    },
    isRefreshNavigation() {
      return this.navigationType === this.navigationTypes.refresh;
    },
    isBackNavigation() {
      return this.navigationType === this.navigationTypes.back;
    },
  },
  created() {
    if (this.isEmptyNavigation && !this._.isNil(this.user())) {
      this.unset(['oauth']);
      if (this.$config.isLegacy) {
        this.$ajax.get('user/me/logout');
      }
    }
  },
});

export default AutoDisconnect;
